import { __exports as a } from "./index.es72.js";
var v;
function x() {
  return v ? a : (v = 1, a.removeElement = function(r) {
    if (r.prev && (r.prev.next = r.next), r.next && (r.next.prev = r.prev), r.parent) {
      var n = r.parent.children;
      n.splice(n.lastIndexOf(r), 1);
    }
  }, a.replaceElement = function(r, n) {
    var t = n.prev = r.prev;
    t && (t.next = n);
    var p = n.next = r.next;
    p && (p.prev = n);
    var i = n.parent = r.parent;
    if (i) {
      var f = i.children;
      f[f.lastIndexOf(r)] = n;
    }
  }, a.appendChild = function(r, n) {
    if (n.parent = r, r.children.push(n) !== 1) {
      var t = r.children[r.children.length - 2];
      t.next = n, n.prev = t, n.next = null;
    }
  }, a.append = function(r, n) {
    var t = r.parent, p = r.next;
    if (n.next = p, n.prev = r, r.next = n, n.parent = t, p) {
      if (p.prev = n, t) {
        var i = t.children;
        i.splice(i.lastIndexOf(p), 0, n);
      }
    } else t && t.children.push(n);
  }, a.prepend = function(r, n) {
    var t = r.parent;
    if (t) {
      var p = t.children;
      p.splice(p.lastIndexOf(r), 0, n);
    }
    r.prev && (r.prev.next = n), n.parent = t, n.prev = r.prev, n.next = r, r.prev = n;
  }, a);
}
export {
  x as __require
};
//# sourceMappingURL=index.es52.js.map
